import React, { FC, useCallback, useEffect, useState } from "react";
import { Popup, Menu as UIMenu } from "@evergis/ui";
import { setLanguageCookie } from "../../evergis/cookie";

import { LanguageButton, LanguageButtonContainer, LanguageMenuContainer, LanguageMenuItem } from "./styled";

import { useToggle } from "../../hooks/useToggle";

import { i18n } from "../../i18n";
import { LANGUAGES } from "./constants";

import { LocalizationMenuProps } from "./types";

import ru from "../../assets/rus.svg";
import en from "../../assets/eng.svg";

export const LocalizationMenu: FC<LocalizationMenuProps> = ({ placement }) => {
  const [isLocalizationVisible, toggleLocalizationPopup] = useToggle(false);
  const [language, setLanguage] = useState<string>(i18n.language);

  const handleLanguageChange = useCallback(
    (newLanguage: string) => {
      if (language !== newLanguage) {
        setLanguage(newLanguage);
      }
    },
    [language],
  );

  useEffect(() => {
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return (
    <Popup
      placement={placement || "right-end"}
      distance={-40}
      anchor={ref => (
        <LanguageButtonContainer ref={ref} placement={placement} onClick={toggleLocalizationPopup}>
          <LanguageButton img={language === LANGUAGES.ru ? ru : en} />
        </LanguageButtonContainer>
      )}
      isVisible={isLocalizationVisible}
      onRequestClose={toggleLocalizationPopup}
    >
      <LanguageMenuContainer>
        <UIMenu
          selectOption={values => {
            setLanguage(values[0]?.value);
            setLanguageCookie(values[0]?.value);
            toggleLocalizationPopup();
          }}
          options={[
            {
              text: <LanguageMenuItem>Русский</LanguageMenuItem>,
              value: LANGUAGES.ru,
            },
            {
              text: <LanguageMenuItem>English</LanguageMenuItem>,
              value: LANGUAGES.en,
            },
          ]}
        />
      </LanguageMenuContainer>
    </Popup>
  );
};
